<template>
  <v-container>
    <v-form ref="form" lazy-validation>
      <v-row>
        <h1 class="title">Register Account</h1>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            :counter="100"
            label="E-mail"
            required
            prepend-icon="mdi-email"
            class="mx-4 my-2"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            :counter="20"
            label="Password"
            required
            prepend-icon="mdi-lock"
            class="mx-4 my-2"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="passwordConfirm"
            :rules="passwordConfirmationRule"
            label="Retype Password"
            required
            prepend-icon="mdi-lock"
            class="mx-4 my-2"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="firstName"
            :rules="firstNameRules"
            :counter="50"
            label="First name"
            required
            prepend-icon="mdi-face"
            class="mx-4 my-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="lastName"
            :rules="lastNameRules"
            :counter="50"
            label="Last name"
            required
            prepend-icon="mdi-face"
            class="mx-4 my-2"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="phoneNumber"
            :rules="phoneNumberRules"
            :counter="20"
            label="Phone number"
            required
            prepend-icon="mdi-dialpad"
            class="mx-4 my-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-radio-group
            v-model="accountType"
            :mandatory="mandatory"
            row
            prepend-icon="mdi-account-box"
            class="mx-4 mt-4"
          >
            <template v-slot:label>
              <div>Account</div>
            </template>
            <v-radio label="Parent" value="1"></v-radio>
            <v-radio label="Teacher" value="2"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <VuetifyGooglePlaces
            :api-key="googleApiKey"
            types="address"
            country="ca"
            placeholder="Address search"
            @placechanged="getAddressData"
            searchIcon="mdi-mail"
            clearIcon="mdi-close"
            :enable-geolocation="true"
            :enable-geocode="false"
            hint="Search your address"
          ></VuetifyGooglePlaces>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="2">
          <v-text-field v-model="unitNumber" label="Unit#" class="mx-4 my-2">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="10">
          <v-text-field
            v-model="addressLineFull"
            id="addressLineFull"
            :filled="true"
            hint="Mailing Address, must end in 'A9A 9A9, Canada' format"
            :persistent-hint="true"
            :outlined="true"
            :readonly="true"
            :clearable="true"
            @click:clear="addressClear"
            :error="!isValidMailingAddress"
            :messages="
              !isValidMailingAddress ? 'Valid Mailing address is required, must end in `A9A 9A9, Canada` format' : ''
            "
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="end">
        <v-btn class="mx-4 my-2" color="primary" text @click="reset">
          clear
        </v-btn>
        <v-btn class="mx-0 my-2" text to="/">Cancel</v-btn>
        <v-btn
          class="mx-4 my-2"
          color="primary"
          @click="submit"
          :loading="loading"
        >
          Submit
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import { validationMixin, errorMessageMixin } from "../shared";
import { VuetifyGooglePlaces } from "vue-google-places";

export default {
  name: "Register",
  mixins: [validationMixin, errorMessageMixin],
  components: { VuetifyGooglePlaces },

  data: () => ({
    googleApiKey: process.env.VUE_APP_GOOGLE_PLACES_API_KEY,
    valid: true,
    email: "",
    showPassword: false,
    password: "",
    passwordConfirm: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    mandatory: true,
    accountType: 1,

    address: "",
    value: "",
    addressLine: "",
    unitNumber: "",

    loading: false
  }),
  computed: {
    passwordConfirmationRule() {
      return [this.password === this.passwordConfirm || "Passwords must match"];
    },
    isValidMailingAddress() {
      return (
        !!this.addressLineFull &&
        /[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} \d{1}[A-Z]{1}\d{1}, Canada/.test(
          this.addressLineFull
        )
      );
    },
    addressLineFull: {
      get: function() {
        return (this.unitNumber + (this.unitNumber ? (this.addressLine ? " - " : "") : "") + this.addressLine).trim();
      },
      set: function(newValue) {
        this.addressLine = (newValue ? newValue : "");
      }
    }
  },
  methods: {
    getAddressData: function(addressData) {
      this.address = addressData;
      console.log("address", this.address);
      this.addressLine = addressData.formatted_address;
    },

    submit() {
      this.$store.state.snackbar = false;
      if (this.$refs.form.validate()) {
        if (!this.isValidMailingAddress) {
          return;
        }

        this.loading = true;
        let registerModel = {
          email: this.email,
          accounttype: this.accountType,
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password,
          phoneNumber: this.phoneNumber,
          addressLine: this.addressLineFull
        };
        this.$store
          .dispatch("register", registerModel)
          .then(() => {
            this.reset();
            this.$store.state.error = "Registration sent. Please check your email to complete the process.";
            this.$store.state.snackbar = true;
            this.$store.state.snackbarColor = "info";

            this.loading = false;
          })
          .catch(err => {
            this.$store.state.error = this.errorMessage(err);
            this.$store.state.snackbar = true;
            console.log(err);
            this.loading = false;
          });
      }
    },
    reset() {
      this.$refs.form.reset();
      this.addressClear();
    },
    addressClear() {
      this.unitNumber = "";
      this.addressLine = "";
    }
  }
};
</script>
